module.exports = __webpack_public_path__ + "media/bootstrap-icons/basket2-a7fac6a1.svg";